var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSmoking = function SvgSmoking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 14.19-1.73-1L7 6.69a3 3 0 0 0-4.1 1.1l-.5.86a3 3 0 0 0 1.1 4.1l13 7.5a3 3 0 0 0 4.1-1.1l.5-.86a3 3 0 0 0-1.1-4.1ZM4.13 9.65l.5-.86A1 1 0 0 1 6 8.42l10.39 6-1.5 2.58L4.5 11a1 1 0 0 1-.37-1.35Zm15.23 7.64-.5.86a1 1 0 0 1-1.37.37l-.87-.5 1.5-2.6.87.5a1 1 0 0 1 .37 1.37Zm-1.43-5.79a1 1 0 0 1-.69-.27 1 1 0 0 1 0-1.41c.39-.34.649-.808.73-1.32-.056-.1-.127-.19-.21-.27a2.37 2.37 0 0 1-.79-1.73 3.838 3.838 0 0 1 1.29-2.71 1.004 1.004 0 1 1 1.42 1.42 2 2 0 0 0-.71 1.29c0 .08 0 .1.23.34a2.28 2.28 0 0 1 .77 1.66 4 4 0 0 1-1.27 2.68 1 1 0 0 1-.77.32Z"
  })));
};

export default SvgSmoking;